export default {
  GENERAL_REMINDER: 'GENERAL_REMINDER',
  APPOINTMENT_REMINDER: 'APPOINTMENT_REMINDER',
  PAYMENT_REMINDER: 'PAYMENT_REMINDER',
  PRODUCTION_REMINDER: 'PRODUCTION_REMINDER',
  TREATMENT_START_REMINDER: 'TREATMENT_START_REMINDER',
  UNPROCESSED_ALIGNER_REMINDER: 'UNPROCESSED_ALIGNER_REMINDER',
} as const
